






import Vue from "vue";
import interceptorsSetup from "./web_client/interceptors";
import { auth } from "@/store";
export default Vue.extend({
  mounted() {
    auth.actions.csrfTokenRequest().then(() => interceptorsSetup());
  },
});
